module.exports = __webpack_public_path__ + "media/elevadizo/buqueCargador-ap-b16289bf.png";